module.exports = __webpack_public_path__ + "img/medical_icon01.ce4663cf.png";